
{
  "fr": {
    "configuratorFooterPriceSummary": {
      "priceLabel": "{price}{pricePerUnit}{totalPriceWithoutVat}",
      "price": "{price}",
      "perUnit": "/gobelet",
      "vatIncluded": "\u00A0TTC",
      "vatExcluded": "\u00A0HT",
      "ie": "Soit"
    }
  }
}
